import { Flex, SkeletonText } from '@volue/wave-react';
import React from 'react';

import { useActions, useAppState } from '@/overmind';

import { ChooseCalculationSet } from './ChooseCalculationSet';
import { LoadingCalculationSetsErrorCard } from './LoadingCalculationSetsErrorCard';

type TacticId = string;

type CalculationSetSubPanelProps = {
  runTactic: (tactic: TacticId) => void;
};

export function CalculationSetSubPanel(props: CalculationSetSubPanelProps) {
  const hasVolueIdentityTokenExpired = useAppState().auth.matches("AUTHENTICATED")?.hasVolueAccessTokenExpired
  const calculationSetExecutionError = useAppState().calculation.calculationTactic.current === 'ERROR'
  const restartApp = useActions().internal.restartApp
  const calculationSets = useAppState().calculation.calculationSets;
  const isCalculationSetRunning =
    useAppState().calculation.calculationTactic.current === 'LOADING';
  const calculationTacticExecutionStatusText =
    useAppState().calculation.calculationTacticExecutionStatusText;
  return (
    <Flex flow="column" gap="spacingS">
      <h4 className="epsilon accent100 fwB">{'Calculate'}</h4>
      {calculationSets.current === 'LOADING' ? (
        <ChooseCalculationSetPlaceholder />
      ) : calculationSets.current === 'LOADED' ? (
        <ChooseCalculationSet
          shouldDisplaySessionExpiredError={Boolean(hasVolueIdentityTokenExpired && calculationSetExecutionError)}
          restartApp={restartApp}
          isCalculationSetRunning={isCalculationSetRunning}
          runCalculationSet={props.runTactic}
          calculationSets={calculationSets.value}
          calculationTacticExecutionStatusText={
            calculationTacticExecutionStatusText
          }
        />
      ) : (
        <LoadingCalculationSetsErrorCard />
      )}
    </Flex>
  );
}

function ChooseCalculationSetPlaceholder() {
  return (
    <>
      <SkeletonText />
      <SkeletonText />
      <SkeletonText />
    </>
  );
}
